import { TemplateResult, html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import { AdoptedStyleSheets } from '../../controllers/adopted-stylesheets';
import encapsulatedStyles from './styles/outline-ratings-comments.inner.pcss?inline';
import globalStyles from './styles/outline-ratings-comments.global.pcss?inline';

/**
 * The OutlineRatingsComments component
 * @element outline-ratings-comments
 */
@customElement('outline-ratings-comments')
export class OutlineRatingsComments extends LitElement {
  adoptedStyleSheets = new AdoptedStyleSheets(this, {
    encapsulatedCSS: encapsulatedStyles,
    globalCSS: globalStyles,
  });

  render(): TemplateResult {
    return html`
      <div class="outline-ratings-comments">
        <div class="heading">
          <slot name="heading"></slot>
        </div>
        <slot name="comments"></slot>
      </div>
    `;
  }
}

// Declare the custom element for TypeScript
declare global {
  interface HTMLElementTagNameMap {
    'outline-ratings-comments': OutlineRatingsComments;
  }
}
